module.exports = "/_next/static/images/UWF-91f9764e03511b236d50331e23303ce8.png";